import { Box, Stack, styled } from '@mui/material';
import { fadeInUp } from '../../utils/animation';

export const CurrentDayDot = styled(Box)(() => ({
  height: '4px',
  width: '4px',
  backgroundColor: '#fff',
  borderRadius: '50%',
  position: 'absolute',
  top: 8,
}));

type AnimatedHourProps = {
  delay?: string;
};

export const AnimatedHour = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'delay',
})<AnimatedHourProps>(({ delay = '0s' }) => ({
  animation: `${fadeInUp} 0.4s ease forwards`,
  animationDelay: delay,
  opacity: 0,
  color: '#fff',
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',
  height: 48,
  width: '100%',
  padding: 1,
  boxSizing: 'border-box',
}));
